import React from "react"

import { Alert, Col, FormGroup, Radio, Row, Thumbnail } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import {
  fillingZeroUtility,
  getFrequencyType,
  renderLoanCollateral
} from "../../lib/utils"
import { Link } from "react-router"
import SimpleCardRow from "../fragments/SimpleCardRow"
import Authenticated from "../../lib/Authenticated"

export default function BundleDetailForm({ bundle, onUpdatePurchaseCost, onUpdateCommissions,
  renderUpdatePurchaseCostForm, renderUpdateCommissionsForm, header }) {

  const { imageId, name, photoUrl, collateralDisabled, shortName, active,
  loanTermFrequency, loanTermFrequencyType, numberOfRepayments, repaymentEvery, repaymentFrequencyType,
  upfrontPayment, loanCollateral, description, commissions, purchaseVAT, sellingVAT, 
  amountFormatted, purchaseAmountFormatted, } = bundle,

  authenticated = new Authenticated(),
  isAdminOrAccountant = authenticated.isAdmin() || authenticated.isAccountant(),

  renderRow = (name, value) => <SimpleCardRow name={ name } value={ value } />,

  renderStatusField = active => (
    <FormGroup>
      <Radio readOnly name="status" inline checked={ active }>
        Active
      </Radio>{' '}
      <Radio readOnly name="status" inline checked={ !active }>
        Inactive
      </Radio>
    </FormGroup>
  ),

  renderUpdatePurchaseCostBtn = () => {

    if (!isAdminOrAccountant || !onUpdatePurchaseCost) return null
  
    return <span className='cursor-pointer hot-color' title='Update'
      onClick={ onUpdatePurchaseCost }>
      Update <FontAwesome name="pencil" />
    </span>
  },

  renderUpdateCommissionsBtn = () => {

    if (!isAdminOrAccountant || !onUpdateCommissions) return null
  
    return <span className='cursor-pointer hot-color' title='Update'
      onClick={ onUpdateCommissions }>
      Update <FontAwesome name="pencil" />
    </span>
  },

  getCommissionLink = (id, text) => {

    let link = ''
    if (id && text) {
      link = !isAdminOrAccountant ? text :
      <Link to={`/loancommission/${id}/detail`} title="View">
        { text }
      </Link>
    }
    return link
  },

  renderCommissions = () => {

    if (renderUpdateCommissionsForm) {
      return renderUpdateCommissionsForm
    }

    const data = (!commissions || !commissions.length) ? '-' :
    commissions.filter(item => !!item).map(({ id, name, disabled }, index) =>
    <li key={ `com${ index }` } className="line-height-25">
      { getCommissionLink(id, name) } &nbsp;{ disabled ? <small className="red">(disabled)</small> : '' }
    </li>)

    return <div className="flex-row">
      <div>{ data }</div>
      { renderUpdateCommissionsBtn() }
    </div>
  },

  renderPurchaseCost = () => renderUpdatePurchaseCostForm ? renderUpdatePurchaseCostForm :
    <div className="flex-row">
      <span>{ purchaseAmountFormatted }</span>
      { renderUpdatePurchaseCostBtn() }
    </div>

  return (
    <Row>

      <Col md={4}>
      { imageId
        ? <Thumbnail href="#" alt={ name } src={ photoUrl } />
        : <div className="align-center">
          <FontAwesome name="suitcase" size="5x" className="bundle-icon bundle-icon-big" />
        </div>
      }
      </Col>

      <Col md={8} className='bundle-detail-content'>

        { collateralDisabled && (
          <Alert bsStyle="warning" bsClass="external-page-alert alert">
            <FontAwesome name="exclamation-circle" size="lg" />{' '}
            The loan collateral has been disabled on this bundle!
          </Alert>
        )}

        { !!header && header }

        <h2 className={ `${ active ? 'blue' : 'red' } mb-20` }>
          { name } <small className="gray">(#{shortName})</small>
        </h2>

        { renderRow('Status', renderStatusField(active)) }

        { renderRow('Selling price (VAT Incl.)', amountFormatted) }

        { renderRow('Purchase cost (VAT Incl.)', renderPurchaseCost()) }

        { renderRow('VAT on Sales', sellingVAT + '%') }

        { renderRow('VAT on Purchases', purchaseVAT + '%') }

        { renderRow('Loan term', `${ fillingZeroUtility(loanTermFrequency) } ${ getFrequencyType(loanTermFrequencyType) }`) }

        { renderRow('Repayments',
          <span>{ fillingZeroUtility(numberOfRepayments) } every&nbsp; 
          { fillingZeroUtility(repaymentEvery) } { getFrequencyType(repaymentFrequencyType) }</span>)}

        { renderRow('Upfront payment', upfrontPayment + '%') }

        { renderRow('Loan Collateral', renderLoanCollateral(loanCollateral)) }

        { renderRow('Description', description) }

        { renderRow('Commissions', renderCommissions()) }
      </Col>
    </Row>
  )
}



// WEBPACK FOOTER //
// ./src/components/Bundles/BundleDetailForm.js